export default function nameSort(a, b) {
  if (!a || !b) {
    return 0;
  }

  const [firstPersonFirstName, firstPersonLastName] = a.person.split(" ");
  const [secondPersonFirstName, secondPersonLastName] = b.person.split(" ");

  if (firstPersonLastName && secondPersonLastName) {
    return firstPersonLastName.localeCompare(secondPersonLastName);
  }

  return firstPersonFirstName.localeCompare(secondPersonFirstName);
}
